import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LucideAngularModule, Download, FileDown, CircleCheckBig, TriangleAlert } from 'lucide-angular';
import { ArticleListItem } from '../../../../core/models/knowledge-base.model';

export interface ArticleExportModalData {
  scopeLabel: string;
  description?: string;
  articles?: ArticleListItem[];
  environmentLabel?: string;
}

type ExportModalState = 'confirm' | 'loading' | 'success' | 'error';

@Component({
  selector: 'app-article-export-modal',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    LucideAngularModule
  ],
  templateUrl: './article-export-modal.component.html',
  styleUrls: ['./article-export-modal.component.scss']
})
export class ArticleExportModalComponent {
  readonly Download = Download;
  readonly FileDown = FileDown;
  readonly CircleCheckBig = CircleCheckBig;
  readonly TriangleAlert = TriangleAlert;

  @Output() readonly confirmRequested = new EventEmitter<void>();

  state: ExportModalState = 'confirm';
  feedbackMessage = '';

  constructor(
    public dialogRef: MatDialogRef<ArticleExportModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ArticleExportModalData
  ) {}

  getMessage(): string {
    return `¿Está seguro que desea exportar ${this.data.scopeLabel}?`;
  }

  onConfirm(): void {
    this.confirmRequested.emit();
  }

  onCancel(): void {
    if (this.state === 'loading') {
      return;
    }
    this.dialogRef.close(false);
  }

  setLoading(message = 'Estamos preparando el archivo. Esto puede tomar unos segundos.'): void {
    this.state = 'loading';
    this.feedbackMessage = message;
    this.dialogRef.disableClose = true;
  }

  setSuccess(message = 'Proceso terminado. La descarga comenzará enseguida.'): void {
    this.state = 'success';
    this.feedbackMessage = message;
    this.dialogRef.disableClose = true;
  }

  setError(message = 'No fue posible exportar la base de conocimiento. Intente nuevamente.'): void {
    this.state = 'error';
    this.feedbackMessage = message;
    this.dialogRef.disableClose = false;
  }

  hasIdentifiers(): boolean {
    return !!this.data.articles && this.data.articles.length > 0;
  }

  shouldShowScrollableList(): boolean {
    return this.hasIdentifiers() && this.data.articles!.length > 5;
  }
}
